import { createClient } from '@sanity/client'
import { config } from './config'

const serverClient = createClient({
  ...config,
  token: process.env.SANITY_API_READ_TOKEN,
})

export const getClient = (preview = false) =>
  serverClient.withConfig({
    perspective: preview ? 'previewDrafts' : 'published',
  })
